export default "__VITE_PUBLIC_ASSET__8828a048__"